var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"title":_vm.label,"alt":_vm.label}},[_c('svg',{attrs:{"viewBox":"2 2 44 44"}},[_vm._t("default"),_c('use',{attrs:{"xlink:href":"#button-click-mask"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }